import React from 'react'

import clsx from 'clsx'

import Typography from 'components/Typography'

import classes from './Label.module.scss'

/** @type {import("./types").default} */
const Label = ({ children, className = '', id }) => (
  <Typography variant="body-sm" component="label" className={clsx('Label', classes.label, className)} id={id}>
    {children}
  </Typography>
)

export default Label
